export default "__VITE_ASSET__DVbBYLbO__"